
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
    Grid, Typography, TextField, FormControl, Select, InputLabel, MenuItem, Button, InputAdornment, IconButton, Modal,
    Box, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckIcon from '@mui/icons-material/Check';
import Helpers from '../Helpers';
import axios from 'axios';
import { Height } from '@mui/icons-material';

const styles = {
    modal: {
        width: '94%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        borderRadius: 2,
        boxShadow: 24,
        p: 1,
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '2px solid #DA0C16',
    },
    btnCloseModal: {
        justifyContent: 'flex-end',
        color: '#DA0C16',
    },
    btnCheckModal: {
        justifyContent: 'flex-end',
        color: '#079C20',
    },
    tableBox: {
        width: '100%',
        height: 400,
        scroll: 'auto'
    },
};

function CadastroCliente(){
    const navigate = useNavigate();
    const location = useLocation();
    const cliente = location.state?.cliente;
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [submitText, setSubmitText] = useState('Salvando registro.');
    const [placeHolderCpfCnpj, setPlaceHolderCpfCnpj] = useState('000.000.000-00');
    const [funcionarioId, setFuncionarioId] = useState(null);
    const [registro, setRegistro] = useState(null);
    const [formIndex, setFormIndex] = useState(0);
    const [selectCidades, setSelectCidades] = useState([]);
    const [selectBairros, setSelectBairros] = useState([]);
    const [selectEnderecos, setSelectEnderecos] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [openC, setOpenC] = useState(false);
    const [openB, setOpenB] = useState(false);
    const [openE, setOpenE] = useState(false);
    const [filtroCidade, setFiltroCidade] = useState('');
    const [filtroBairro, setFiltroBairro] = useState('');
    const [filtroEndereco, setFiltroEndereco] = useState('');

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            setFuncionarioId(user.id_funcionario);
        }
    };

    const getSelectsApi = async() => {
        Helpers.loadingAlert('Atualizando listas');

        const rota = `${urlApi}/${funcionarioId}/tabelas`;
        const resposta = await axios.get(rota);

        setSelectCidades(resposta.data.cidades);
        setSelectBairros(resposta.data.bairros);
        setSelectEnderecos(resposta.data.enderecos);
    };

    useEffect(() => {
        getAuth();

        if(funcionarioId !== null){
            getSelectsApi();
            setRegistro((prev) => ({ ...prev, id_funcionario: funcionarioId }));
        }
    }, [funcionarioId]);

    useEffect(() => {
        if (cliente !== null){
            setSubmitText('Atualizando registro.');

            setRegistro({
                id: cliente.id,
                registro_id: cliente.registro_id,
                cd_cliente: cliente.cd_parceiro,
                rz_social: cliente.rz_social,
                nm_fantasia: cliente.nm_fantasia,
                tp_pessoa: cliente.tp_pessoa,
                id_tabpreco: cliente.id_tabpreco,
                gr_stjuridica: cliente.gr_stjuridica,
                gr_vrprodsemimposto: cliente.gr_vrprodsemimposto,
                id_funcionario: cliente.id_funcionario,
                id_regiao: cliente.id_regiao,
                id_uf: cliente.id_uf,
                id_cidade: cliente.id_cidade,
                id_bairro: cliente.id_bairro,
                id_endereco: cliente.id_endereco,
                dt_cadastro: cliente.dt_cadastro,
                dt_ultpedido: cliente.dt_ultpedido,
                ds_telefone: cliente.ds_telefone,
                ds_cgc_cpf: cliente.ds_cgc_cpf,
                ds_cidade: cliente.ds_cidade,
                ds_bairro: cliente.ds_bairro,
                ds_endereco: cliente.ds_endereco,
                nr_endereco: cliente.nr_endereco,
                cp_endereco: cliente.cp_endereco,
                ds_cep: cliente.ds_cep,
                ds_email: cliente.ds_email,
                ds_observacao: cliente.ds_observacao,
                tp_telefone: cliente.tp_telefone,
            });
        }else{
            setSubmitText('Salvando registro.');

            setRegistro({
                id: 0,
                registro_id: 0,
                cd_cliente: 0,
                rz_social: '',
                nm_fantasia: '',
                tp_pessoa: 'F',
                id_tabpreco: 0,
                gr_stjuridica: 'N',
                gr_vrprodsemimposto: 'S',
                id_funcionario: funcionarioId,
                id_regiao: 0,
                id_uf: 0,
                id_cidade: 0,
                id_bairro: 0,
                id_endereco: 0,
                dt_cadastro: '',
                dt_ultpedido: '',
                ds_telefone: '',
                ds_cgc_cpf: '',
                ds_cidade: '',
                ds_bairro: '',
                ds_endereco: '',
                nr_endereco: '',
                cp_endereco: '',
                ds_cep: '',
                ds_email: '',
                ds_observacao: '',
                tp_telefone: 'C',
                cidadeSel: '',
                bairroSel: '',
                enderecoSel: '',
            });
        }
    }, [cliente]);

    const handleOpen = (tpModal) => {
        setListaFiltrada([]);

        if(tpModal === 'C'){
            setFiltroCidade('');
            setOpenC(true);
        }else if(tpModal === 'B'){
            setFiltroBairro('');
            setOpenB(true);
        }else if(tpModal === 'E'){
            setFiltroEndereco('');
            setOpenE(true);
        }
    };

    const handleClose = () => {
        setOpenC(false);
        setOpenB(false);
        setOpenE(false);
    };

    const handlePesquisaCidade = (dsCidade) => {
        if(dsCidade.length > 0){
            const resultado = selectCidades.filter(item => {
                let ds_registro = item.ds_registro;
                return ds_registro.toLowerCase().includes(dsCidade.toLowerCase());
            });

            console.log('resultado', resultado);

            if(resultado.length > 0){
                setListaFiltrada(resultado);
            }else{
                setListaFiltrada([]);

                return Helpers.toastAlert({
                    title: 'Nenhum registro encontrado.',
                    icon: 'warning'
                });
            }
        }
    };

    const handleSelecionaCidade = (idCidade, dsCidade) => {
        setRegistro(prev => ({
            ...prev,
            id_cidade: idCidade,
            ds_cidade: dsCidade
        }));

        setFiltroCidade('');
        setListaFiltrada([]);
        handleClose();
    };

    const handlePesquisaBairro = (dsBairro) => {
        if(dsBairro.length > 0){
            const resultado = selectBairros.filter(item => {
                let ds_registro = item.ds_registro;
                return ds_registro.toLowerCase().includes(dsBairro.toLowerCase());
            });

            if(resultado.length > 0){
                setListaFiltrada(resultado);
            }else{
                setListaFiltrada([]);

                return Helpers.toastAlert({
                    title: 'Nenhum registro encontrado.',
                    icon: 'warning'
                });
            }
        }
    };

    const handleSelecionaBairro = (idBairro, dsBairro) => {
        setRegistro(prev => ({
            ...prev,
            id_bairro: idBairro,
            ds_bairro: dsBairro
        }));

        setFiltroBairro('');
        setListaFiltrada([]);
        handleClose();
    };

    const handlePesquisaEndereco = (dsEndereco, idCidade) => {
        if(dsEndereco.length > 0){
            const enderecosFiltrados = selectEnderecos.filter(item => Number(item.id_cidade) === Number(idCidade));
            
            const resultado = enderecosFiltrados.filter(item => {
                let ds_registro = item.ds_registro;
                return ds_registro.toLowerCase().includes(dsEndereco.toLowerCase());
            });

            if(resultado.length > 0){
                setListaFiltrada(resultado);
            }else{
                setListaFiltrada([]);

                return Helpers.toastAlert({
                    title: 'Nenhum registro encontrado.',
                    icon: 'warning'
                });
            }
        }
    };

    const handleSelecionaEndereco = (idEndereco, dsEndereco) => {
        console.log(registro);
        console.log(dsEndereco, idEndereco);

        setRegistro(prev => ({
            ...prev,
            id_endereco: idEndereco,
            ds_endereco: dsEndereco
        }));

        setFiltroEndereco('');
        setListaFiltrada([]);
        handleClose();
    };

    const handleChangeTpPessoa = (e) => {
        let tpPessoa = e.target.value;

        setPlaceHolderCpfCnpj((tpPessoa === 'F' ? '000.000.000-00' : '00.000.000/000-00'));
        setRegistro((prev) => ({ ...prev, tp_pessoa: tpPessoa }));
        setRegistro((prev) => ({ ...prev, ds_cgc_cpf: '' }));
    };

    const handleValidaCpfCnpj = () => {
        const eValido = Helpers.validadorCpfCnpj(registro.ds_cgc_cpf);
        return eValido;
    };
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        Helpers.loadingAlert(submitText);

        handleValidaCpfCnpj();
        
        if(registro.rz_social == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar a razão social",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(registro.nm_fantasia == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar o nome fantasia",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(registro.ds_cgc_cpf == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar o cpf ou cnpj",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(registro.ds_cgc_cpf != '' && registro.ds_cgc_cpf.length < 11 && registro.tp_pessoa === 'F'){
            Helpers.toastAlert({
                title: "O cpf precisa ter 11 dígitos",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(registro.ds_cgc_cpf != '' && registro.ds_cgc_cpf.length < 14 && registro.tp_pessoa === 'J'){
            Helpers.toastAlert({
                title: "O cnpj precisa ter 14 dígitos",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(!handleValidaCpfCnpj()){
            Helpers.toastAlert({
                title: "Cpf / Cnpj inválido, verifique o número informado.",
                icon: "warning",
            }); 

            setFormIndex(0);
            return;
        }else if(registro.id_cidade == '0'){
            Helpers.toastAlert({
                title: "É necessário cadastrar a cidade",
                icon: "warning",
            }); 

            setFormIndex(1);
            return;
        }else if(registro.id_bairro == '0'){
            Helpers.toastAlert({
                message: "É necessário cadastrar o bairro",
                type: "warning",
            }); 

            return;
        }else if(registro.id_endereco == '0' || registro.nr_endereco == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar o endereço e o número",
                icon: "warning",
            }); 

            setFormIndex(1);
            return;
        }else if(registro.ds_cep == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar o cep",
                icon: "warning",
            }); 

            setFormIndex(1);
            return;
        }else if(registro.ds_telefone == ''){
            Helpers.toastAlert({
                title: "É necessário cadastrar o telefone de contato",
                icon: "warning",
            }); 

            setFormIndex(2);
            return;
        }else{
            const rota = `${urlApi}/cliente-store-update`;

            await axios.post(rota, registro, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                Helpers.toastAlert({
                    title: `${response.data.titulo} ${response.data.mensagem}`,
                    icon: "success",
                });

                navigate('/clientes');
            }).catch((err) => {
                console.log('erro context', err.message);
            });
        }
    };

    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid size={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }} >
                <Button 
                    variant="contained" 
                    size="small" 
                    startIcon={<ArrowBackIcon />} 
                    onClick={()=> navigate('/clientes')}
                    sx={{ backgroundColor: '#f5f5f5', color: 'rgba(0,0,0, .8)' }}
                > 
                    sair
                </Button>

                <Typography
                    sx={{
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        fontSize: 14,
                    }}
                >
                    { (cliente === null) ? 'Cadastrar novo cliente' : 'Atualizar cliente' }
                </Typography>
            </Grid>

            {
                (formIndex === 0) &&
                <>
                    <Grid size={12}>
                        <Typography sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16' }}>Informações gerais</Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField 
                            id="rz_social" 
                            label="Razão social" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.rz_social}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, rz_social: Helpers.maxLenght(e.target.value, 100)  }))
                            }
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField 
                            id="nm_fantasia" 
                            label="Nome fantasia" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.nm_fantasia}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, nm_fantasia: Helpers.maxLenght(e.target.value, 100) }))
                            }
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth>
                            <InputLabel id="tp_pessoa" shrink>Tipo pessoa</InputLabel>
                            <Select
                                labelId="tp_pessoa"
                                id="tp_pessoa_select"
                                label="Tipo pessoa"
                                size="small"
                                value={registro?.tp_pessoa ?? ''} /// não aparece a opção F como default, o select vem vazio
                                onChange={handleChangeTpPessoa}
                                sx={{ backgroundColor: '#f5f5f5' }}
                                notched
                            >
                                <MenuItem value={'F'}>FÍSICA</MenuItem>
                                <MenuItem value={'J'}>JURÍDICA</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField
                            id="cpf_cnpj" 
                            label="Cpf / Cnpj" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.ds_cgc_cpf}
                            onBlur={handleValidaCpfCnpj}
                            onChange={(e) => 
                                setRegistro((prev) => ({ ...prev, ds_cgc_cpf: Helpers.mascaraCpfCnpj(e.target.value, registro.tp_pessoa) }))
                            }
                            placeholder={placeHolderCpfCnpj}
                            slotProps={{ inputLabel: { shrink: true } }}
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={12} columnSpacing={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button 
                            variant="contained" 
                            size="small" 
                            endIcon={<KeyboardArrowRightIcon />} 
                            color="error" 
                            onClick={()=> setFormIndex(1)}
                        > 
                            Próximo 
                        </Button>
                    </Grid>
                </>
            }
            {
                (formIndex === 1) &&
                <>
                    <Grid size={12}>
                        <Typography sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16' }}>Endereço</Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField
                            label="Cidade"
                            size="small"
                            value={registro?.ds_cidade}
                            fullWidth
                            disabled
                            InputLabelProps={{ shrink: true }} 
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={()=>handleOpen('C')} edge="end">
                                        <ManageSearchIcon />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }}
                        />

                        {/* MODAL PARA A ESCOLHA DA CIDADE */}
                        <Modal open={openC} onClose={handleClose} >
                            <Box sx={styles.modal}>
                                <Box sx={styles.header}>
                                    <Typography variant="h6" component="h3"> Pesquisar cidade </Typography>
                                    <Button onClick={()=>handleClose()} startIcon={<HighlightOffIcon />} style={styles.btnCloseModal} />
                                </Box>

                                <TextField
                                    size="small"
                                    fullWidth
                                    onChange={(e)=>setFiltroCidade(e.target.value.slice(0,50))}
                                    sx={{ mt: 2, mb: 2 }}
                                    InputLabelProps={{ shrink: true }} 
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={()=>handlePesquisaCidade(filtroCidade)} edge="end">
                                                    <ManageSearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
                                    <Table size="small" stickyHeader sx={{ width: '100%' }}>
                                        <TableBody>
                                        {
                                            (listaFiltrada.length > 0) &&
                                            listaFiltrada.map((item, index)=>{
                                                return (
                                                    <TableRow key={index} >
                                                        <TableCell component="th" scope="row">{item.ds_registro}</TableCell>
                                                        <TableCell align="right">
                                                            <Button 
                                                                onClick={()=>handleSelecionaCidade(item.id, item.ds_registro)} 
                                                                startIcon={<CheckIcon />} 
                                                                style={styles.btnCheckModal} 
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Modal>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField
                            label="Bairro"
                            size="small"
                            value={registro?.ds_bairro}
                            fullWidth
                            disabled
                            InputLabelProps={{ shrink: true }} 
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={()=>handleOpen('B')} edge="end">
                                        <ManageSearchIcon />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }}
                        />

                        {/* MODAL PARA A ESCOLHA DO BAIRRO */}
                        <Modal open={openB} onClose={handleClose} >
                            <Box sx={styles.modal}>
                                <Box sx={styles.header}>
                                    <Typography variant="h6" component="h3"> Pesquisar bairro </Typography>
                                    <Button onClick={()=>handleClose()} startIcon={<HighlightOffIcon />} style={styles.btnCloseModal} />
                                </Box>

                                <TextField
                                    size="small"
                                    fullWidth
                                    onChange={(e)=>setFiltroBairro(e.target.value.slice(0,50))}
                                    sx={{ mt: 2, mb: 2 }}
                                    InputLabelProps={{ shrink: true }} 
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={()=>handlePesquisaBairro(filtroBairro)} edge="end">
                                                    <ManageSearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
                                    <Table size="small" stickyHeader sx={{ width: '100%' }}>
                                        <TableBody>
                                        {
                                            (listaFiltrada.length > 0) &&
                                            listaFiltrada.map((item, index)=>{
                                                return (
                                                    <TableRow key={index} >
                                                        <TableCell component="th" scope="row">{item.ds_registro}</TableCell>
                                                        <TableCell align="right">
                                                            <Button 
                                                                onClick={()=>handleSelecionaBairro(item.id, item.ds_registro)} 
                                                                startIcon={<CheckIcon />} 
                                                                style={styles.btnCheckModal} 
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Modal>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField
                            label="Endereço"
                            size="small"
                            value={registro?.ds_endereco}
                            fullWidth
                            disabled
                            InputLabelProps={{ shrink: true }} 
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={()=>handleOpen('E')} edge="end">
                                        <ManageSearchIcon />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }}
                        />

                        {/* MODAL PARA A ESCOLHA DO ENDEREÇO */}
                        <Modal open={openE} onClose={handleClose} >
                            <Box sx={styles.modal}>
                                <Box sx={styles.header}>
                                    <Typography variant="h6" component="h3"> Pesquisar endereço </Typography>
                                    <Button onClick={()=>handleClose()} startIcon={<HighlightOffIcon />} style={styles.btnCloseModal} />
                                </Box>

                                <TextField
                                    size="small"
                                    fullWidth
                                    onChange={(e)=>setFiltroEndereco(e.target.value.slice(0,50))}
                                    sx={{ mt: 2, mb: 2 }}
                                    InputLabelProps={{ shrink: true }} 
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={()=>handlePesquisaEndereco(filtroEndereco, registro.id_cidade)} edge="end">
                                                    <ManageSearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
                                    <Table size="small" stickyHeader sx={{ width: '100%' }}>
                                        <TableBody>
                                        {
                                            (listaFiltrada.length > 0) &&
                                            listaFiltrada.map((item, index)=>{
                                                return (
                                                    <TableRow key={index} >
                                                        <TableCell component="th" scope="row">{item.ds_registro}</TableCell>
                                                        <TableCell align="right">
                                                            <Button 
                                                                onClick={()=>handleSelecionaEndereco(item.id, item.ds_registro)} 
                                                                startIcon={<CheckIcon />} 
                                                                style={styles.btnCheckModal} 
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Modal>
                    </Grid>

                    <Grid size={{ xs: 4, md: 1 }}>
                        <TextField 
                            id="nr_endereco" 
                            label="Nrº endereço" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.nr_endereco}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, nr_endereco: e.target.value.slice(0,5) }))
                            }
                            sx={{ backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={{ xs: 8, md: 2 }}>
                        <TextField 
                            id="ds_cep" 
                            label="Cep" 
                            variant="outlined"
                            size="small"
                            type='decimal'
                            fullWidth 
                            value={registro?.ds_cep}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, ds_cep: Helpers.mascaraCep(e.target.value) }))
                            }
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 9 }}>
                        <TextField 
                            id="cp_endereco" 
                            label="Complemento endereço" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.cp_endereco}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, cp_endereco: e.target.value.slice(0,30) }))
                            }
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button 
                            variant="contained" 
                            size="small" 
                            startIcon={<KeyboardArrowLeftIcon />} 
                            color="error" 
                            onClick={()=> setFormIndex(0)}
                        > 
                            anterior 
                        </Button>

                        <Button 
                            variant="contained" 
                            size="small" 
                            endIcon={<KeyboardArrowRightIcon />} 
                            color="error" 
                            onClick={()=> setFormIndex(2)}
                        > 
                            Próximo 
                        </Button>
                    </Grid>
                </>
            }
            {
                (formIndex === 2) &&
                <>
                    <Grid size={12}>
                        <Typography sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16' }}>Contato</Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth>
                            <InputLabel id="tp_telefone">Tipo telefone</InputLabel>
                            <Select
                                labelId="tp_telefone"
                                id="tp_telefone_select"
                                label="Tipo telefone"
                                size="small"
                                defaultValue={registro?.tp_telefone}
                                onChange={(e) => 
                                    setRegistro((prev) => ({ ...prev, tp_telefone: e.target.value }))
                                }
                                sx={{ backgroundColor: '#f5f5f5' }}
                            >
                                <MenuItem value={'C'}>CELULAR</MenuItem>
                                <MenuItem value={'O'}>COMERCIAL</MenuItem>
                                <MenuItem value={'R'}>RESIDENCIAL</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField 
                            id="ds_telefone" 
                            label="Telefone" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={registro?.ds_telefone}
                            onChange={(e) =>
                                setRegistro((prev) => ({ ...prev, ds_telefone: Helpers.mascaraTelefones(e.target.value) }))
                            }
                            sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}
                        />
                    </Grid>

                    <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button 
                            variant="contained" 
                            size="small" 
                            startIcon={<KeyboardArrowLeftIcon />} 
                            color="error" 
                            onClick={()=> setFormIndex(1)}
                        > 
                            anterior 
                        </Button>

                        <Button 
                            variant="contained" 
                            size="small" 
                            endIcon={<SaveAsIcon />} 
                            color="success" 
                            onClick={handleSubmit}
                        > 
                            Salvar 
                        </Button>
                    </Grid>
                </>
            }
        </Grid>
    );
}

export default CadastroCliente;